import React from 'react';
import { colors } from '../theme';
import { deviceList, isDeviceDone, REPAIR_STATE_LABELS } from '../utils/rmaDevices';

// The units covered by a bundled case (issue #712). Renders nothing for an
// ordinary single-device case, so it can be dropped into any stage modal.
// `showState` adds the per-unit repair outcome (useful from repair onwards).
export default function RmaDeviceList({ rma, title = 'Units on this case', showState = false }) {
  const devices = deviceList(rma);
  if (devices.length <= 1) return null;

  return (
    <div style={wrap}>
      <div style={heading}>
        {title} <span style={{ color: colors.primary }}>({devices.length})</span>
      </div>
      {devices.map((d, i) => (
        <div key={d.serialNumber || i} style={row}>
          <span style={index}>{i + 1}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, color: colors.textStrong }}>
              {d.serialNumber}
              {d.isPrimary && <span style={tag}>primary</span>}
            </div>
            <div style={{ fontSize: '0.72rem', color: colors.textMuted }}>
              {[d.productNumber, d.issueType].filter(Boolean).join(' · ')}
            </div>
            {d.description && (
              <div style={{ fontSize: '0.72rem', color: colors.textMuted, marginTop: '0.15rem' }}>
                {d.description}
              </div>
            )}
            {d.sourceRmaId && (
              <div style={{ fontSize: '0.68rem', color: colors.textDim, marginTop: '0.15rem' }}>
                bundled from {d.sourceRmaId}
              </div>
            )}
          </div>
          {showState && (
            <span style={{
              fontSize: '0.7rem',
              fontWeight: 700,
              flexShrink: 0,
              color: isDeviceDone(d) ? '#46bb89' : '#fb923c',
            }}>
              {REPAIR_STATE_LABELS[d?.repair?.state || 'pending']}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}

const wrap = {
  border: `1px solid ${colors.panelBorder}`,
  borderRadius: 8,
  padding: '0.6rem 0.75rem',
  margin: '0.6rem 0',
  background: 'rgba(255,255,255,0.03)',
};
const heading = {
  fontSize: '0.72rem',
  fontWeight: 700,
  color: colors.textMuted,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  marginBottom: '0.45rem',
};
const row = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.6rem',
  padding: '0.35rem 0',
  borderTop: `1px solid ${colors.panelBorder}`,
  fontSize: '0.82rem',
};
const index = {
  fontSize: '0.7rem',
  fontWeight: 700,
  color: colors.textDim,
  minWidth: 16,
};
const tag = {
  marginLeft: '0.4rem',
  fontSize: '0.62rem',
  fontWeight: 700,
  color: '#46bb89',
  background: 'rgba(70,187,137,0.14)',
  border: '1px solid rgba(70,187,137,0.35)',
  borderRadius: 999,
  padding: '0.05rem 0.35rem',
};
